import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Section.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/components/ui/button.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.26.10_supports-color@7.2.0__react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
